export const RESET = 'EXSBSETTLEMENT_LIST_RESET'
export const SET_ITEMS = 'EXSBSETTLEMENT_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBSETTLEMENT_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBSETTLEMENT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBSETTLEMENT_LIST_TOGGLE_LOADING'
